import { useState } from 'react';
import { Link } from 'react-router-dom';
import { templates, templateCategories } from '@/mocks/templates';

export default function TemplatesSection() {
  const [activeCategory, setActiveCategory] = useState('全部');

  const filteredTemplates = activeCategory === '全部'
    ? templates
    : templates.filter((t) => t.category === activeCategory);

  return (
    <section className="w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-sm font-medium mb-4">
            精选模板
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4 font-heading">
            数百款精美模板，覆盖全行业
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            专业设计师倾心打造，无论你是什么行业，都能找到合适的建站模板。
          </p>
        </div>

        <div className="flex items-center justify-center flex-wrap gap-2 mb-10">
          {templateCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredTemplates.map((tpl) => (
            <Link
              key={tpl.id}
              to="/category/all"
              className="group block rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-[240px] overflow-hidden">
                <img
                  src={tpl.image}
                  alt={tpl.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${tpl.name} - 免费在线成网站模板`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                  <span className="px-5 py-2 rounded-full bg-background-50 text-foreground-950 text-sm font-medium whitespace-nowrap">
                    查看详情
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">
                  {tpl.name}
                </h3>
                <p className="text-sm text-foreground-600 mb-3 line-clamp-2">
                  {tpl.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {tpl.features.map((f) => (
                    <span
                      key={f}
                      className="px-2.5 py-1 rounded-md bg-background-200/50 text-xs text-foreground-600 whitespace-nowrap"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-sm font-medium text-foreground-700 hover:border-foreground-500 hover:text-foreground-950 transition-all duration-200 whitespace-nowrap"
          >
            查看更多模板
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}